import routes from './routes';
import SetRoutes from '../../components/setRoutes';

const DataExportPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default DataExportPage;
